import React from 'react';
import { Button, Divider, Dropdown, List, Menu, Select, Spin, Typography } from 'antd';
import { DeleteOutlined, EditOutlined, MoreOutlined, PlusOutlined } from '@ant-design/icons';
import ContactSidebarItem from '../ContactSidebarItem';

const { Text } = Typography;

const SidebarList = ({
    virtualChannels = [],
    selectedChannelId,
    selectedChannel,
    channelsLoading,
    channelOptions = [],
    contacts,
    contactsLoading,
    selectedContactId,
    testConversation,
    conversationByContactId,
    hoveredContactId,
    setHoveredContactId,
    isMobile,
    isDarkMode,
    t,
    onChannelChange,
    onAddChannel,
    onEditChannel = () => { },
    onDeleteChannel = () => { },
    onAddContact,
    onSelectContact,
    onDeleteContact
}) => {
    const listThemeColors = {
        background: isDarkMode ? '#1f1f1f' : '#fff',
        selectedBackground: isDarkMode ? '#183a61' : '#e6f7ff',
        hoverBackground: isDarkMode ? '#2a2a2a' : '#f5f5f5',
        text: isDarkMode ? 'rgba(255, 255, 255, 0.85)' : 'rgba(0, 0, 0, 0.88)',
        secondaryText: isDarkMode ? 'rgba(255, 255, 255, 0.45)' : 'rgba(0, 0, 0, 0.45)'
    };

    const channelActions = (
        <Menu>
            <Menu.Item key="edit" icon={<EditOutlined />} disabled={!selectedChannel} onClick={() => onEditChannel(selectedChannel)}>
                {t('edit_virtual_channel', { defaultValue: 'Edit virtual channel' })}
            </Menu.Item>
            <Menu.Item key="delete" icon={<DeleteOutlined />} danger disabled={!selectedChannel} onClick={() => onDeleteChannel(selectedChannel)}>
                {t('delete_virtual_channel', { defaultValue: 'Delete virtual channel' })}
            </Menu.Item>
        </Menu>
    );

    return (
        <div className="agent-test-sidebar-list" style={{ display: 'flex', flexDirection: 'column', height: '100%', minHeight: 0 }}>
            <div style={{ padding: isMobile ? '16px 14px 12px' : '12px 8px', borderBottom: `1px solid ${isDarkMode ? '#303030' : '#f0f0f0'}` }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8, marginBottom: 8 }}>
                    <Text type="secondary" style={{ display: 'block', fontSize: 12 }}>
                        {t('virtual_channel', { defaultValue: 'Virtual channel' })}
                    </Text>
                    <Dropdown overlay={channelActions} trigger={['click']}>
                        <Button
                            aria-label={t('virtual_channel_actions', { defaultValue: 'Virtual channel actions' })}
                            icon={<MoreOutlined />}
                            type="text"
                            size="small"
                        />
                    </Dropdown>
                </div>
                <Select
                    value={selectedChannelId}
                    loading={channelsLoading}
                    options={channelOptions}
                    placeholder={t('select_channel', { defaultValue: 'Select channel' })}
                    optionLabelProp="title"
                    onChange={onChannelChange}
                    style={{ width: '100%', marginBottom: 8 }}
                    dropdownRender={(menu) => (
                        <>
                            {menu}
                            <Divider style={{ margin: '8px 0' }} />
                            <Button
                                type="text"
                                icon={<PlusOutlined />}
                                onClick={onAddChannel}
                                block
                            >
                                {t('add_channel', { defaultValue: 'Add channel' })}
                            </Button>
                        </>
                    )}
                />
                {selectedChannel?.description && (
                    <Text
                        type="secondary"
                        title={selectedChannel.description}
                        style={{
                            display: 'block',
                            fontSize: 12,
                            marginBottom: 10,
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap'
                        }}
                    >
                        {selectedChannel.description}
                    </Text>
                )}
                <Button
                    aria-label={t('create_virtual_contact', { defaultValue: 'Create virtual contact' })}
                    icon={<PlusOutlined />}
                    type="primary"
                    block
                    disabled={!virtualChannels.length || !selectedChannelId}
                    onClick={onAddContact}
                >
                    {t('create_virtual_contact', { defaultValue: 'Create virtual contact' })}
                </Button>
            </div>

            {contactsLoading && (
                <div style={{ display: 'flex', justifyContent: 'center', padding: '8px 0' }}>
                    <Spin size="small" />
                </div>
            )}

            <List
                style={{ overflow: 'auto', padding: isMobile ? '4px 0' : '8px 0', background: listThemeColors.background, flex: 1, minHeight: 0 }}
                dataSource={contacts}
                locale={{ emptyText: t('no_contacts') }}
                renderItem={(contact) => {
                    const isActive = contact?.id && contact.id === selectedContactId;
                    const bgColor = isActive
                        ? listThemeColors.selectedBackground
                        : (hoveredContactId === contact?.id ? listThemeColors.hoverBackground : listThemeColors.background);
                    const conversation = isActive
                        ? testConversation
                        : (contact?.id ? conversationByContactId?.[contact.id] : null);

                    return (
                        <ContactSidebarItem
                            contact={contact}
                            conversation={conversation}
                            isActive={isActive}
                            isMobile={isMobile}
                            isDarkMode={isDarkMode}
                            t={t}
                            listThemeColors={listThemeColors}
                            bgColor={bgColor}
                            hoveredContactId={hoveredContactId}
                            setHoveredContactId={setHoveredContactId}
                            onSelect={() => onSelectContact(contact)}
                            onDelete={() => onDeleteContact(contact)}
                        />
                    );
                }}
            />
        </div>
    );
};

export default SidebarList;













